module.exports = __webpack_public_path__ + "img/asso_jeju02.8b507856.png";